export enum FormStatusEnum {
  SUBMITTED = "submitted",
  DRAFT = "draft",
  PENDING_SIGNOFF = "pending-signoff",
  VOIDED = "voided",
}

export const FormStatusEnumToText = {
  [FormStatusEnum.SUBMITTED]: "Submitted",
  [FormStatusEnum.DRAFT]: "Draft",
  [FormStatusEnum.PENDING_SIGNOFF]: "Pending Signoff",
  [FormStatusEnum.VOIDED]: "Voided",
};
